export default [
  {
    header: 'Menu',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Dashboard',
    icon: 'HomeIcon',
    route: 'dashboard',
    action: 'read',
    resource: 'ACL',
  },
  // Alerts by organization
  {
    title: 'Alertas',
    icon: 'AlertTriangleIcon',
    children: [
      {
        title: 'Historial',
        route: 'alerts-history',
        action: 'read',
        resource: 'ACL',
      },
      {
        title: 'Configuración',
        route: 'alerts-config',
        action: 'read',
        resource: 'Tech',
      },
    ],
  },
]
